// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__12oSv","requiredAsterisk":"Info_requiredAsterisk__2-nma"};